import { TtademplocationServiceApi } from '../../shared/sdk/services/custom/TtademplocationService';
import { SFAttendanceApi } from '../../shared/sdk/services/custom/SFAttendance';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, LoadingController, Events, Platform } from 'ionic-angular';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Storage } from '@ionic/storage';
import { ToastServiceProvider } from '../toast-service/toast.service';
import { SettingServiceApi, SFAttUploadSF6Api, SFAttendanceSF6Api, WorkLocationApi } from '../../shared/sdk';
import { AlertServiceProvider } from '../alert-service/alert-service';
import { Camera } from '@ionic-native/camera';
import { File, Entry } from '@ionic-native/file';
import { PermissionCheckProvider } from '../permission-check/permission-check';
import { Diagnostic } from '@ionic-native/diagnostic';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { TranslateService } from '@ngx-translate/core';
import { StoragePathProvider } from '../storage-path/storage-path';
import { AttendanceApi } from '../../shared/nestjs/gd-only/services/attendance.api';
import { AttendanceBloc } from '../../bloc/hr/attendance/attendance.bloc';
import { AnalyticsProvider } from '../analytics/analytics';
import { GreatdayPluginNative } from '../../native/greatday-plugin.native';
import { GlobalServiceProvider } from '../global-service/global-service';
import { AppPreferences } from '../../shared/local/app-preferences.local';
import { EventNameAnalytics } from '../../helpers/event-name-analytics';


@Injectable()
export class ActivityRecordingProvider {

  SFGoAuth: any;
  languageCode = {
    en: "en", // english
    id: "in", // indonesia
    jp: "ja", // jepang
    th: "th", // thailand
    cn: "zh", // china
    kr: "ko", // korea
    my: "ms" // malaysia
  }

  private params = {
    setting: {
      attendanceLock: false, // regulating attendance may be outside the specified area or not
      cameraLock: true, // setting may skip camera or not
      checkRoot: false, // setting when record attendance , check root (fake gps) or not
      webAbsent: true, // setting for user to record from web or not
      showPosting: false, // setting for enabled or disabled posting
      checkFakeGPS: false, // setting for enabled or disabled posting
      checkAutoTime: true, // setting for enabled or disabled check automatic datetime
      offlineMode: true, // setting for check access page offline mode
      showEmpNo: true,
      takePhoto: true,
      attendanceFace: false,
      attendanceLockPrompt: false, // force and show alert if user outside coverage area
      allowRoot: false
    },
  }

  constructor(
    public http: HttpClient,
    public greatdayPluginNative: GreatdayPluginNative,
    public alertCtrl: AlertController,
    public storage: Storage,
    public sfattendanceApi: SFAttendanceApi,
    public loadingCtrl: LoadingController,
    public camera: Camera,
    public toastService: ToastServiceProvider,
    public settingServiceApi: SettingServiceApi,
    public alertService: AlertServiceProvider,
    public events: Events,
    public platform: Platform,
    public file: File,
    public ttademplocationServiceApi: TtademplocationServiceApi,
    public permissionCheckProvider: PermissionCheckProvider,
    public diagnostic: Diagnostic,
    public barcodeScanner: BarcodeScanner,
    public translate: TranslateService,
    public storagePath: StoragePathProvider,
    public transfer: FileTransfer,
    public sfattuploadsf6Api: SFAttUploadSF6Api,
    public GDAttendanceApi: AttendanceApi,
    public sfattendancesf6Api: SFAttendanceSF6Api,
    public workLocationApi: WorkLocationApi,
    public attendanceBloc: AttendanceBloc,
    public analyticsProvider: AnalyticsProvider,
    public globalServiceProvider: GlobalServiceProvider,
    public appPreferences: AppPreferences
  ) {
    this.storage.get('SFGoAuth').then(hasil => {
      this.SFGoAuth = JSON.parse(hasil);
    });
  }


  async getGeolocation(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        // get language
        let language = await this.getLanguage();
        let langCode = this.languageCode[language];

        // get worklocation
        let workLocation = await this.storage.get("attWorkLocation");

        // label for maps
        const label1 = this.translate.instant('Is the location of your activity recording correct?');
        const label2 = this.translate.instant('GPS must have high accuracy enabled to record your activity');

        // console.log("TCL: langCode", langCode)
        // console.log("TCL: workLocation", workLocation)
        // console.log("TCL: label1", label1)
        // console.log("TCL: label2", label2)

        const customPlugin = await this.greatdayPluginNative.getCustomGeolocation(label1, label2, langCode, workLocation);
        resolve(customPlugin)
      }
      catch (error) {
        console.log(error);
        resolve({ cancelled: true, camera: {}, geolocation: {} })
      }
    })
  }

  async getLanguage(): Promise<any> {
    return new Promise(async (resolve) => {
      let lang = await this.storage.get('language');
      let result = lang ? lang : "en";

      resolve(result);
    })
  }

  copyFile(imageData: string): Promise<string> {
    return new Promise(async (resolve) => {
      const path = await this.permissionCheckProvider.getPathActivityRecord();
      let newPath = path.nativeURL;
      let oldPath = encodeURI(imageData.replace(imageData.substr(imageData.lastIndexOf('/') + 1), ""));
      let fileName = imageData.substr(imageData.lastIndexOf('/') + 1);

      this.file.copyFile(oldPath, fileName, newPath, fileName)
        .then((entry: Entry) => {
          console.log('copy file success', entry)
          this.removeFile(imageData);
          resolve(entry.nativeURL);
        })
        .catch(error => {
          console.log('copy file error', error)
          resolve(imageData);
        })
    })
  }

  removeFile(file: string) {
    let path = file.substring(0, file.lastIndexOf('/') + 1);
    let fileName = file.substring(file.lastIndexOf('/') + 1);

    this.file.removeFile(path, fileName).then((result) => {
      console.log('remove result', result)
    }).catch(error => {
      console.log('remove error', error)
    });
  }

  getFileDirectoryActivityRecord(): Promise<Array<any>> {
    return new Promise(async (resolve) => {
      let result = [];
      try {
        result = await this.file.listDir(this.file.dataDirectory, 'ActivityRecord');
      }
      catch (error) {
        console.log('TCL: error get file', error);
      }
      resolve(result);
    })
  }

  async checkMockLocation() {
    // Get setting service attendance
    const setting = await this.attendanceBloc.getAttendanceSetting();
    this.params.setting = setting;
    let isMock = false;
    let packageMock = [];
    let whiteList = [];

    try {
      // check if user has indicated mock apps
      if (this.params.setting.checkFakeGPS) {
        let chekMock: any = {};
        if (this.platform.is('android')) {
          const storageWhiteList = await this.storage.get('whiteListPackage');
          whiteList = [];
          if (storageWhiteList != null) {
            for (let packageName of storageWhiteList.data) {
              whiteList.push(packageName.package)
            }
          }
          chekMock = await this.attendanceBloc.checkMock(whiteList);
        } else {
          chekMock.isMock = false;
        }

        if (chekMock.isMock) {
          isMock = chekMock.isMock;
          packageMock = chekMock.indicated;
          throw new Error(chekMock.messages);
        }
      }
    } catch (e) {
      if (isMock) {
        //  GA
        this.analyticsProvider.trackEvent(EventNameAnalytics.ACTIVITY_RECORDING_CHECK_FAKE_GPS, e.message)
        const value = await this.alertService.createMolaMock(e.message, packageMock)
        if (value) {
          // return ketika klik button list
          return { mockDetect: true, value: value }
        } else {
          // return ketika klik button close
          return { mockDetect: true, value: false };
        }
      } else {
        //  GA
        this.analyticsProvider.trackEvent(EventNameAnalytics.ACTIVITY_RECORDING_CHECK_FAKE_GPS, e.message)
        await this.alertService.createMola(e.message)
        return { mockDetect: false };
      }
    }

  }

  async writeFile(base64: string, fileName: string) {
    try {
      this.SFGoAuth = await this.appPreferences.getAuth();
      const path = await this.permissionCheckProvider.getPathActivityRecord();
      const base64ToFile = await this.globalServiceProvider.convertBase64toBlob(base64);
      const writeFile = await this.file.writeFile(path.nativeURL, fileName, base64ToFile as Blob);
      return writeFile.nativeURL;
    } catch (error) {
      console.log('TCL" error write file', error);
    }
  }

}





// WEBPACK FOOTER //
// ./src/providers/activity-recording/activity-recording.ts